import { render, staticRenderFns } from "./modalAddMaterial.vue?vue&type=template&id=0cbab24c&scoped=true"
import script from "./modalAddMaterial.vue?vue&type=script&lang=js"
export * from "./modalAddMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbab24c",
  null
  
)

export default component.exports